import React from 'react';
import PropTypes from 'prop-types';

const NoData = ({ description = 'You have no records for this selection.' }) => (
  <div className="margin-responsive text-align-center">
    <h3 className="dls-gray-04">{description}</h3>
  </div>
);

NoData.propTypes = {
  description: PropTypes.string,
};

export default NoData;
